/**
 * Default screen users land on after authentication.
 */
export const DEFAULT_LANDING_ROUTE = '/dashboard';
